export const NUMBER_FIELD_WARNING = 'A numeric value is expected.';

export const PLAIN_NUMERIC_VALUE_PATTERN = '^-?(?:\\d+(?:\\.\\d*)?|\\.\\d+)$';

export const PLAIN_NUMERIC_VALUE_REGEX = new RegExp(PLAIN_NUMERIC_VALUE_PATTERN);

const NUMBER_GROUP_FORMATTER = new Intl.NumberFormat('en-US');

export function shouldShowNumberFieldWarning(value: string | undefined): boolean {
  return Boolean(value?.trim()) && !/\d/.test(value ?? '');
}

export function getPlainNumericText(value: string): string | null {
  const trimmed = value.trim();
  if (!PLAIN_NUMERIC_VALUE_REGEX.test(trimmed)) return null;
  return trimmed;
}

export function getPlainNumericValue(value: string): number | null {
  const numericText = getPlainNumericText(value);
  if (numericText === null) return null;

  const num = Number(numericText);
  return Number.isFinite(num) ? num : null;
}

export function formatNumberFieldValue(value: string): string {
  const numericText = getPlainNumericText(value);
  if (numericText === null) return value;

  const sign = numericText.startsWith('-') ? '-' : '';
  const [integerDigits = '', fractionDigits] = numericText.slice(sign.length).split('.');
  const groupedInteger = integerDigits ? NUMBER_GROUP_FORMATTER.format(BigInt(integerDigits)) : '';
  const fraction = typeof fractionDigits === 'string' ? `.${fractionDigits}` : '';

  return `${sign}${groupedInteger}${fraction}`;
}
